export default "__VITE_ASSET__BpE88liH__"